var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"285","height":"150","viewBox":"0 0 585 550","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M214.82 453.268L59.8271 307.427L128.751 242.573L214.82 323.789L455.883 96.7324L524.807 161.587L214.82 453.268Z","fill":"#074A74"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }